import { render, staticRenderFns } from "./AIEvaluationComponent_v2.vue?vue&type=template&id=3c8d125e&scoped=true&"
import script from "./AIEvaluationComponent_v2.vue?vue&type=script&lang=js&"
export * from "./AIEvaluationComponent_v2.vue?vue&type=script&lang=js&"
import style0 from "./AIEvaluationComponent_v2.vue?vue&type=style&index=0&id=3c8d125e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8d125e",
  null
  
)

export default component.exports